// icon:fullscreen-exit | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

function IconFullscreenExit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M14 14h5v2h-3v3h-2v-5m-9 0h5v5H8v-3H5v-2m3-9h2v5H5V8h3V5m11 3v2h-5V5h2v3h3z" />
    </svg>
  );
}

export default IconFullscreenExit;
